import { render, staticRenderFns } from "./BeautyCategoryAddon.vue?vue&type=template&id=a9a0daa0&scoped=true"
import script from "./BeautyCategoryAddon.vue?vue&type=script&lang=js"
export * from "./BeautyCategoryAddon.vue?vue&type=script&lang=js"
import style0 from "./BeautyCategoryAddon.vue?vue&type=style&index=0&id=a9a0daa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a0daa0",
  null
  
)

export default component.exports